/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_HowInputs */

const en_portal_nav_how = /** @type {(inputs: Portal_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const pl_portal_nav_how = /** @type {(inputs: Portal_Nav_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to działa`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Portal_Nav_HowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_how = /** @type {((inputs?: Portal_Nav_HowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_HowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_how(inputs)
	return en_portal_nav_how(inputs)
});